import { OrbitControlCameraTupleMapper } from "./OrbitControlCameraTupleMapper";
import { CameraPath } from "./CameraPath";
import { CameraTuple } from "./CameraTuple";

declare const STAGE: any;

interface IPromiseCallbacks {
  resolve: () => void;
  reject: (reason?: Error) => void;
}

export class CameraPathRunner {
  static runningInstances = new Set<CameraPathRunner>();

  running: boolean;
  t0: number;
  orbitControlCameraTupleMapper: OrbitControlCameraTupleMapper;
  cameraPath: CameraPath;
  duration: number;
  promiseCallbacks: IPromiseCallbacks | null;

  constructor(cameraPath: CameraPath, duration: number) {
    this.running = false;
    this.t0 = 0;
    this.orbitControlCameraTupleMapper = new OrbitControlCameraTupleMapper();
    this.cameraPath = cameraPath;
    this.duration = duration;
    this.promiseCallbacks = null;
    STAGE.orbitcontrols.addEventListener("start", (): void => this.stop());
  }

  start(): Promise<void> | undefined {
    if (this.running) {
      return;
    }
    this.t0 = Date.now();
    this.running = true;
    CameraPathRunner.runningInstances.add(this);
    requestAnimationFrame((): void => this.update());
    return new Promise<void>((resolve: () => void, reject: (reason?: Error) => void): void => {
      this.promiseCallbacks = { resolve, reject };
    });
  }

  stop(): void {
    this.running = false;
    this.promiseCallbacks?.resolve();
    this.promiseCallbacks = null;
    CameraPathRunner.runningInstances.delete(this);
  }

  static stopAll(): void {
    CameraPathRunner.runningInstances.forEach((instance: CameraPathRunner): void => instance.stop());
    CameraPathRunner.runningInstances.clear();
  }

  update(timestamp?: number): void {
    if (!this.running) {
      return;
    }
    this.performCameraStep(Date.now());
    requestAnimationFrame((): void => this.update());
  }

  performCameraStep(timestamp: number): void {
    const t = (timestamp - this.t0) / this.duration;
    if (t >= 0.99999) {
      const cameraTuple = this.cameraPath.getAt(1);
      this.orbitControlCameraTupleMapper.setCurrentCamera(cameraTuple);
      this.stop();
      return;
    }
    const cameraTuple = this.cameraPath.getAt(t);
    this.orbitControlCameraTupleMapper.setCurrentCamera(cameraTuple);
  }
}
